export const MAX_VISIBLE_GROUPS = {
  lg: 3,
  '2xl': 5,
  '4xl': 7
} as const;
